import { api } from "@/api/client";
import type { EntityLookupValue } from "@/components/shared/EntityLookup";

export const MENSAGERIA_PATH = "instituicao/Mensageria";

export interface Mensageria {
  idMensageria: number;
  texto: string;
  tipo: "A" | "E" | "N";
  dataValidade?: string | null;
  seLiberado: "S" | "N";
  // Opcional: sem instituição = mensagem geral (todas as instituições).
  // A listagem devolve `instituicao` (entity); o GET por id devolve só o
  // `instituicaoId` com garantia — a descrição é resolvida via getInstituicaoLookup.
  instituicaoId?: number | null;
  instituicao?: { id: number; nomeFantasia?: string } | null;
}

export interface MensageriaFiltro {
  texto?: string;
  tipo?: string;
  seLiberado?: string;
  // `instituicao` só alimenta o <EntityLookup> do filtro; o backend lê `instituicaoId`.
  instituicao?: EntityLookupValue;
  instituicaoId?: number;
  // Ambos já em "yyyy-MM-ddTHH:mm:ss" (dataValidadeTermino em 23:59:59) —
  // ver ConsultaMensageria.tsx e lib/format.ts (toLocalDateTimeString).
  dataValidadeInicio?: string;
  dataValidadeTermino?: string;
}

export async function getMensageria(id: number): Promise<Mensageria> {
  const { data } = await api.get<Mensageria>(`${MENSAGERIA_PATH}/${id}`);
  return data;
}

// Legado sempre usa POST tanto pra criar quanto pra editar (o backend decide
// pelo id no corpo) — ver app/controllers/consulta-mensageria.controller.js.
export async function saveMensageria(registro: Partial<Mensageria>): Promise<Mensageria> {
  const { data } = await api.post<Mensageria>(MENSAGERIA_PATH, registro);
  return data;
}

export async function deleteMensageria(id: number): Promise<void> {
  await api.delete(`${MENSAGERIA_PATH}/${id}`);
}
